<template>
  <div class="consignorAccount">
    <div class="center">
      <template slot="label">
        <!-- 插槽 -->
        <slot name="label"></slot>
      </template>
      <div class="information">
        <el-form :model="informationData" label-width="120px" label-position="right" :rules="rules" ref="ruleForm" class="demo-ruleForm">
          <el-row>
            <el-col :span="14">
              <el-form-item label="合计含税费用:" label-width="120px">
                {{ informationData.sumIncluded }}
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="合计不含税费用:" label-width="120px">
                <div style="display: flex; flex-direction: row; align-items: center">
                  <div>{{ informationData.sumNotIncluded }}</div>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="标题:" prop="title" label-width="120px">
            <el-input size="mini" placeholder="请输入对账单标题" v-model="informationData.title"></el-input>
          </el-form-item>
          <el-form-item label="税率:" prop="taxRate" label-width="120px" v-if="$route.path == '/settle/discount'">
            <el-input size="mini" placeholder="请输入税率" v-model="informationData.taxRate" type="number"></el-input>
          </el-form-item>
          <el-form-item label="是否抵扣开票:" label-width="120px" prop="isInvoicing">
            <el-radio-group v-model="informationData.isInvoicing" @change="isInvoicingChange">
              <el-radio :label="0">否</el-radio>
              <el-radio :label="1">是</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-row :gutter="24" v-if="informationData.isInvoicing === 1">
            <el-col :span="13">
              <el-form-item label="选择抵扣费用：" style="margin-bottom: 17px; width: 100%" class="costList" prop="instruction">
                <el-select
                  size="mini"
                  filterable
                  v-model="informationData.instruction"
                  placeholder="请选择抵扣费用数据"
                  style="width: 100%"
                  @change="
                    value => {
                      this.informationData.Deductible = value.remainingDiscountAmount;
                    }
                  ">
                  <el-option v-for="item in InvoicingList" :key="item.id" :value="item" :label="item.deductionNum"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="抵扣费用：" label-width="90px" style="margin-bottom: 17px" prop="Deductible">
                <el-input size="mini" v-model="informationData.Deductible" style="width: 180px" :disabled="informationData.instruction ? false : true" :placeholder="informationData.instruction ? '请输入抵扣费用' : '请先选择抵扣费用数据'">
                  <i slot="suffix" class="input-right">元</i>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="最多抵扣费用：" label-width="130px" style="margin-bottom: 17px" prop="remainingDiscountAmount">
                <span>{{ informationData.remainingDiscountAmount }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="备注:" label-width="120px">
            <el-input size="mini" placeholder="请输入备注" :autosize="{ minRows: 5, maxRows: 10 }" v-model="informationData.remark" style="width: 90%" type="textarea"></el-input>
          </el-form-item>
          <el-form-item style="margin-left: 80px">
            <el-button type="primary" size="mini" @click="confirmButton">确认</el-button>
            <el-button type="info" size="mini" @click="dialogClose">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
  import { updatePrice } from '@/service/financial';
  import { add, elseAdd } from '@/service/contract';
  import consignorAccount from '@/views/settle/entrust/components/consignorAccount.vue';
  import consignorResourcesCarAccount from '@/views/settle/entrust/components/consignorResourcesCarAccount.vue';
  import divBorder from '@/components/divBorder.vue';
  import { customerAdd, deductionInvoicingCostGetAllByCompanyId } from '@/service/getData';
  import otherAdd from '@/views/settle/supplier/components/otherAdd.vue';
  import { formatTime } from '@/config/mUtils';

  export default {
    components: { divBorder, consignorResourcesCarAccount, consignorAccount, otherAdd },
    name: 'accountState',
    props: {
      checkTableData: {
        default: [],
      },
      importShow: {
        default: false,
      },
      dialogCloseParent: {
        type: Function,
        require: true,
        default: null,
      },
      initType: {
        default: '',
      },
    },
    data() {
      return {
        activeName: 'information',
        dialogWith: '950px',
        tableData: [],
        informationData: {
          taxRate: '', // 税率
          company: '', // 公司名称
          setType: 1, // 结算方式
          sumIncluded: '', // 合计含税费用
          sumNotIncluded: '', // 合计不含税费用
          title: '', //
          IsoilPrice: 0,
          isInvoicing: 0, // 是否抵扣开票
          instruction: '', // 选择抵扣费用
          Deductible: '', // 抵扣费用
          remainingDiscountAmount: 0, // 最高抵扣费用
          remark: '',
          settIds: '',
        },
        InvoicingList: [], // 选择抵扣费用 下拉
        sumContract: 0,
        sumNotIncluded: 0,
        consignorId: '', //公司id
        oldCompany: '', // 原公司
        ruleForm: {
          title: '',
          isInvoicing: '',
          instruction: '',
          Deductible: '',
        },
        rules: {
          taxRate: {
            required: true,
            message: '请输入税率',
            trigger: 'blur',
          },
          plan: {
            required: true,
            message: ' ',
            trigger: 'blur',
          },
          title: {
            required: true,
            message: '请输入对账单标题',
            trigger: 'blur',
          },
          isInvoicing: {
            required: true,
            message: '请选择是否抵扣开票',
            trigger: 'blur',
          },
          instruction: {
            required: true,
            message: '请选择抵扣费用数据',
            trigger: 'blur',
          },
          Deductible: {
            required: true,
            message: '请输入抵扣费用',
            trigger: 'blur',
          },
        },
        type: '',
      };
    },
    methods: {
      closeFormData() {
        this.informationData.title = '';
        this.informationData.remark = '';
      },
      init(data) {
        this.tableData = JSON.parse(JSON.stringify(data));
        this.informationData.sumIncluded = this.calculation(this.tableData, 'costAmount');
        this.informationData.sumNotIncluded = this.calculation(this.tableData, 'excludingTaxAmount');
        this.informationData.company = this.oldCompany = this.tableData[0].companyName;
      },
      init1(data) {
        this.tableData = JSON.parse(JSON.stringify(data));
        this.informationData.sumIncluded = this.calculation(this.tableData, 'discountAmount');
        this.informationData.sumNotIncluded = 0;
        this.informationData.company = this.oldCompany = this.tableData[0].companyName;
      },
      isInvoicingChange(value) {
        const id = this.tableData.length > 0 ? this.tableData[0].companyId : '';
        if (value == 1) {
          this._deductionInvoicingCostGetAllByCompanyId(id);
        }
      },
      // 获取最大抵扣金额
      async _deductionInvoicingCostGetAllByCompanyId(id) {
        const res = await deductionInvoicingCostGetAllByCompanyId(id);
        if (res.status !== 0) return this.$message.error(res.message);
        this.informationData.remainingDiscountAmount = res.data[0].remainingDiscountAmount;
        this.InvoicingList = res.data.map(item => ({
          id: item.id,
          deductionNum: item.instruction,
          remainingDiscountAmount: item.remainingDiscountAmount,
        }));
      },
      async _customerAdd() {
        console.log(this.initType);
        const { company, sumIncluded, sumNotIncluded, title, isInvoicing, instruction, IsoilPrice, Deductible, settIds, remark, taxRate } = this.informationData;
        let otherCostIds = '';
        this.tableData.forEach((item, index) => {
          // 最后一个不加逗号
          otherCostIds += index === this.tableData.length - 1 ? item.id : `${item.id},`;
        });
        if (this.initType == 'discount') {
          const obj = {
            companyId: this.tableData[0].companyId,
            companyNameOld: this.oldCompany,
            companyNameNew: company,
            setType: this.informationData.setType,
            taxPrice: Number(sumIncluded),
            noTaxPrice: Number(sumNotIncluded),
            deductIds: this.tableData.length > 0 ? otherCostIds : '',
            isOilPrice: IsoilPrice,
            title,
            isDeduct: isInvoicing,
            deductId: instruction.id,
            deductAmount: Deductible,
            remark,
            type: this.tableData[0].companyType === 0 ? 18 : 19,
            settIds: settIds,
          };
          if (this.$route.path == '/settle/discount') {
            obj['taxRate'] = Number(taxRate);
            obj['taxRateStr'] = taxRate;
          }
          // if (isInvoicing === 1) {
          //   delete obj.deductAmount;
          // }
          const res = await elseAdd(obj);
          if (res.status !== 0) return this.$message.error(res.message);
          this.$message.success(res.message);
          this.$parent.$parent.searchBtn();
          this.dialogClose();
        }
        if (this.initType == 'else') {
          const obj = {
            companyId: this.tableData[0].companyId,
            companyNameOld: this.oldCompany,
            companyNameNew: company,
            setType: this.informationData.setType,
            taxPrice: Number(sumIncluded),
            noTaxPrice: Number(sumNotIncluded),
            otherCostIds: this.tableData.length > 0 ? otherCostIds : '',
            isOilPrice: IsoilPrice,
            title,
            isDeduct: isInvoicing,
            deductId: instruction.id,
            deductAmount: Deductible,
            remark,
            type: this.tableData[0].companyType === 0 ? 16 : 17,
            settIds: settIds,
          };
          // if (isInvoicing === 1) {
          //   delete obj.deductAmount;
          // }
          const res = await elseAdd(obj);
          if (res.status !== 0) return this.$message.error(res.message);
          this.$message.success(res.message);
          this.$parent.$parent.searchBtn();
          this.dialogClose();
        }
      },

      // 确认生成对账单
      confirmButton() {
        this.$refs.ruleForm.validate(async valid => {
          if (valid) {
            await this._customerAdd();
          } else {
          }
        });
      },
      //关闭
      dialogClose() {
        this.activeName = 'information';
        this.$parent.$parent.dialogElseClose();
        // 清空
        for (const informationDataKey in this.informationData) {
          this.informationData[informationDataKey] = '';
        }
        // 清除提示
        this.$refs.ruleForm.resetFields();
      },
      // 清除数据 父组件调用
      clearData() {
        for (const informationDataKey in this.informationData) {
          this.informationData[informationDataKey] = '';
        }
        // 清除提示
        this.$refs.ruleForm.resetFields();
      },
      calculation(table, zi) {
        let sum = 0;
        table.forEach(item => {
          sum += Number(item[zi]);
        });
        return sum.toFixed(2);
      },
    },
  };
</script>
<style scoped lang="scss"></style>
